import React from "react";

/*
    Cancel Icon
    props:
        - title: string, override the default title 'Cancel'
        - color: string, override the default color '#00549A' (bell blue)
*/

const CancelIcon = (props) => (
    <svg className={props.className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "Cancel"}</title>
        <path
            d="M4.5 4.5L8 8M11.5 11.5L8 8M8 8L11.5 4.5M8 8L4.5 11.5"
            stroke={props.color || "#00549A"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default CancelIcon;
